function addEvent(e) {
    window.dataLayer.push(e);
};

export default {addEvent};